/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as HappyFace } from '../../assets/svg/face-happy.svg';
export default HappyFace;
